import './eventschedule.css';

function EventSchedule() {

  function getNextSecondOrFourthSunday(fromDate = new Date()) {
  const date = new Date(fromDate); // clone so we don't mutate input
  date.setHours(0, 0, 0, 0); // reset time

  // loop day by day until we find the 2nd or 4th Sunday
    while (true) {
      date.setDate(date.getDate() + 1);
      const dayOfWeek = date.getDay(); // 0 = Sunday
      const weekNumber = Math.ceil(date.getDate() / 7);

      if (dayOfWeek === 0 && (weekNumber === 2 || weekNumber === 4)) {
        return date;
      }
    }
  }
  // Example usage:
  const nextSpecialSunday = getNextSecondOrFourthSunday();
  
  function getNextSunday(fromDate = new Date()) {
    const date = new Date(fromDate);
    date.setHours(0, 0, 0, 0);

    const dayOfWeek = date.getDay(); // 0 = Sunday
    if (dayOfWeek === 0) {
    // Today is Sunday, return today
    return date;
    }
    const daysToAdd = (7 - dayOfWeek) % 7 || 7; // if today is Sunday, go to next Sunday
    date.setDate(date.getDate() + daysToAdd);

    return date;
  }
  const nextSunday = getNextSunday();
    return (
      <section id="events-1652">
          <div className="cs-container">
              <div className="cs-events">
                  <div className="cs-content">
                      <span className="cs-topper">Sathya Sai Center Milwaukee - Events</span>
                      <h2 className="cs-title">Upcoming Events</h2>
                  </div>
                  <ul className="cs-card-group">
                      <li className="cs-item">
                          <span className="cs-date">
                              <strong>
                                {nextSunday.toLocaleDateString(undefined, {day: 'numeric'})}
                              </strong>
                              {nextSunday.toLocaleDateString(undefined, {month: 'short' })}
                          </span>
                          <div className="cs-info-wrapper">
                              <div className="cs-info">
                                  <h3 className="cs-h3">SSE Class And Study Circle</h3>
                                  <span className="cs-location">2418 W Mangold Ave, Milwaukee, WI</span>
                                  <span className="cs-time">
                                      <img className="cs-icon" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/gold-clock.svg" alt="icon" width="24" height="24" loading="lazy" decoding="async" aria-hidden="true"></img>
                                      03:00PM - 4:00PM
                                  </span>
                              </div>
                              <div className="cs-button-wrapper">
                                  <a href="/sse" className="cs-button-solid">SSE Program</a>
                              </div>
                          </div>
                      </li>
                      <li className="cs-item">
                          <span className="cs-date">
                              <strong>
                                {nextSunday.toLocaleDateString(undefined, {day: 'numeric'})}
                              </strong>
                              {nextSunday.toLocaleDateString(undefined, {month: 'short' })}
                          </span>
                          <div className="cs-info-wrapper">
                              <div className="cs-info">
                                  <h3 className="cs-h3">Bhajan and Prayer</h3>
                                  <span className="cs-location">2418 W Mangold Ave, Milwaukee, WI</span>
                                  <span className="cs-time">
                                      <img className="cs-icon" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/gold-clock.svg" alt="icon" width="24" height="24" loading="lazy" decoding="async" aria-hidden="true"></img>
                                      04:00PM - 5:00PM
                                  </span>
                              </div>
                              <div className="cs-button-wrapper">
                                  <a href="" className="cs-button-solid">Bhajan</a>
                              </div>
                          </div>
                      </li>
                      <li className="cs-item">
                          <span className="cs-date">
                              <strong>
                                {nextSpecialSunday.toLocaleDateString(undefined, {day: 'numeric'})}
                              </strong>
                                {nextSpecialSunday.toLocaleDateString(undefined, {month: 'short' })}
                          </span>
                          <div className="cs-info-wrapper">
                              <div className="cs-info">
                                  <h3 className="cs-h3">Sandwich Service Activity</h3>
                                  <span className="cs-location">2418 W Mangold Ave, Milwaukee, WI</span>
                                  <span className="cs-time">
                                      <img className="cs-icon" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/gold-clock.svg" alt="icon" width="24" height="24" loading="lazy" decoding="async" aria-hidden="true"></img>
                                      2:30PM - 3:00PM
                                  </span>
                              </div>
                              <div className="cs-button-wrapper">
                                  <a href="/service" className="cs-button-solid">Volunteer</a>
                              </div>
                          </div>
                      </li>
                  </ul>
              </div>
          </div> 
      </section>
    );
}

export default EventSchedule;